export const testimonialsData = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    position: 'CEO, TechCorp Financial',
    company: 'TechCorp',
    content: 'Working with this team was transformative. They didn\'t just build a product—they understood our vision and turned it into reality. The platform has exceeded all our expectations.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1758873268631-fa944fc5cad2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwY3JlYXRpdmUlMjBidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzc4MzI3MzI5fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 2,
    name: 'Marcus Chen',
    position: 'Founder, StyleHub Retail',
    company: 'StyleHub',
    content: 'The brand transformation they delivered was phenomenal. Our online presence went from forgettable to award-winning. Sales have never been better.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1758873268631-fa944fc5cad2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwY3JlYXRpdmUlMjBidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzc4MzI3MzI5fDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 3,
    name: 'Dr. Emily Rodriguez',
    position: 'CTO, MediConnect',
    company: 'MediConnect',
    content: 'They built a HIPAA-compliant healthcare app that our patients love. The attention to security, user experience, and functionality was outstanding.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1758873268631-fa944fc5cad2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwY3JlYXRpdmUlMjBidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzc4MzI3MzI5fDA&ixlib=rb-4.1.0&q=85'
  }
];